/**
 * YouTube URL helpers. Browser-safe (no API key, no logger), so the web form
 * can validate a link with the same parser the server uses.
 */

/** Video id shape shared with coverage-group URL expansion. */
const YOUTUBE_VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{6,20}$/;

/**
 * Extract a YouTube video id (and whether it was a Shorts link) from a URL.
 * Canonical home for the logic also used by coverage-group URL expansion.
 * Returns null for non-YouTube URLs or URLs without a recognizable video id.
 */
export function extractYouTubeVideoId(
	url: string,
): { videoId: string; isShort: boolean } | null {
	let parsed: URL;
	try {
		parsed = new URL(url);
	} catch {
		return null;
	}

	const host = parsed.hostname.toLowerCase().replace(/^www\./, "");
	let videoId: string | null = null;
	let isShort = false;

	if (host === "youtu.be") {
		videoId = parsed.pathname.split("/").filter(Boolean)[0] ?? null;
	} else if (host === "youtube.com" || host === "m.youtube.com") {
		const segments = parsed.pathname.split("/").filter(Boolean);
		if (parsed.pathname === "/watch") {
			videoId = parsed.searchParams.get("v");
		} else if (segments[0] === "shorts" && segments[1]) {
			videoId = segments[1];
			isShort = true;
		} else if (
			(segments[0] === "embed" || segments[0] === "live") &&
			segments[1]
		) {
			videoId = segments[1];
		}
	}

	if (!videoId || !YOUTUBE_VIDEO_ID_PATTERN.test(videoId)) {
		return null;
	}
	return { videoId, isShort };
}
